import { render, staticRenderFns } from "./employment-doc-view.vue?vue&type=template&id=65e5913d&scoped=true"
import script from "./employment-doc-view.vue?vue&type=script&lang=js"
export * from "./employment-doc-view.vue?vue&type=script&lang=js"
import style0 from "./employment-doc-view.vue?vue&type=style&index=0&id=65e5913d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e5913d",
  null
  
)

export default component.exports